import React from "react";
import { Invitations } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <Invitations />
      </>
    </div>
  );
}
